import React from 'react';
import { Code, Palette, Server, Wrench } from 'lucide-react';
import { useInView } from 'react-intersection-observer';

const iconMap = {
  Code: Code,
  Palette: Palette,
  Server: Server,
  Wrench: Wrench
};

const Skills = ({ data }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  return (
    <section id="skills" className="py-24 bg-[#0F0F0F]">
      <div className="container mx-auto px-6">
        <div 
          ref={ref}
          className={`max-w-6xl mx-auto transition-all duration-1000 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-16 text-center">
            Skills & <span className="text-[#0066FF]">Expertise</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            {data.map((skill, index) => {
              const IconComponent = iconMap[skill.icon];
              return (
                <div 
                  key={index}
                  className="bg-[#1A1A1A] rounded-2xl p-8 border border-white/10 hover:border-[#0066FF]/50 transition-all duration-500 hover:transform hover:scale-105 hover:shadow-xl hover:shadow-[#0066FF]/10"
                  style={{
                    transitionDelay: `${index * 100}ms`
                  }}
                >
                  <div className="flex items-center gap-4 mb-6">
                    <div className="p-3 bg-[#0066FF]/10 rounded-xl">
                      <IconComponent className="text-[#0066FF]" size={32} />
                    </div>
                    <h3 className="text-2xl font-bold text-white">
                      {skill.category}
                    </h3>
                  </div>

                  <div className="flex flex-wrap gap-3">
                    {skill.items.map((item, idx) => (
                      <span 
                        key={idx}
                        className="px-4 py-2 bg-[#0A0A0A] text-gray-300 rounded-lg text-sm border border-white/5 hover:border-[#0066FF]/50 hover:text-[#0066FF] transition-all duration-300 cursor-default"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
